import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { usePlay, Panel, Stat } from "./usePlay";
import { BetControl } from "@/components/game/BetControl";
import { fmtAZN } from "@/lib/api";
import { sfx } from "@/lib/sound";

const Face = ({ side }) => (
  <div className="absolute inset-0 rounded-full flex items-center justify-center font-display font-black text-6xl"
    style={{
      backfaceVisibility: "hidden", transform: side === "tails" ? "rotateY(180deg)" : "none",
      background: side === "heads" ? "radial-gradient(circle at 30% 30%, #fff3b0, #FFD700 35%, #b8921f 75%, #6b520c)" : "radial-gradient(circle at 30% 30%, #ffffff, #d4d4d8 35%, #8a8a93 75%, #3f3f46)",
      boxShadow: "inset 0 0 0 10px rgba(255,255,255,0.18), inset 0 -10px 20px rgba(0,0,0,0.35), 0 20px 50px rgba(0,0,0,0.7)",
      color: side === "heads" ? "#5c4508" : "#27272a",
    }}>{side === "heads" ? "J" : "AZ"}</div>
);

export const CoinFlipGame = ({ mode }) => {
  const { busy, play, finish } = usePlay(mode);
  const [bet, setBet] = useState(1);
  const [side, setSide] = useState("heads");
  const [rot, setRot] = useState(0);
  const [res, setRes] = useState(null);
  const pending = useRef(null);

  const go = async () => {
    setRes(null);
    const d = await play("/games/coinflip", { bet, side });
    if (!d) return;
    pending.current = d;
    sfx.flip();
    setRot((r) => r - (r % 360) + 1800 + (d.result === "tails" ? 180 : 0));
  };

  const done = () => {
    const d = pending.current;
    if (!d) return;
    pending.current = null;
    setRes(d); sfx.reelStop(); finish(d);
  };

  return (
    <div className="grid lg:grid-cols-[340px_1fr] gap-6" data-testid="coinflip-game">
      <Panel className="order-2 lg:order-1">
        <div><p className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">Mərc</p><BetControl value={bet} onChange={setBet} disabled={busy} testid="coin-bet" /></div>
        <div className="grid grid-cols-2 gap-2">
          {[["heads", "Qızıl"], ["tails", "Gümüş"]].map(([v, l]) => (
            <button key={v} disabled={busy} onClick={() => setSide(v)} className={`rounded-xl py-3 font-display font-bold transition-colors ${side === v ? "bg-[#D4AF37] text-black" : "bg-white/5 hover:bg-white/10"}`} data-testid={`coin-side-${v}`}>{l}</button>
          ))}
        </div>
        <div className="grid grid-cols-2 gap-2"><Stat label="Əmsal" value="x1.94" /><Stat label="Qazanc" value={fmtAZN(bet * 1.94)} /></div>
        <button disabled={busy} onClick={go} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="coin-flip-btn">At</button>
      </Panel>
      <div className="machine-frame rounded-3xl p-10 order-1 lg:order-2 flex flex-col items-center justify-center gap-8 min-h-[380px]" style={{ perspective: 1000 }}>
        <motion.div animate={{ rotateY: rot, y: busy ? [0, -120, 0] : 0 }} transition={{ duration: 1.6, ease: "easeOut" }} onAnimationComplete={done}
          className="relative w-44 h-44 sm:w-56 sm:h-56" style={{ transformStyle: "preserve-3d" }} data-testid="coin">
          <Face side="heads" /><Face side="tails" />
        </motion.div>
        <p className={`font-display font-bold text-2xl h-8 ${res ? (res.won ? "text-emerald-400" : "text-red-500") : ""}`} data-testid="coin-result">
          {res ? `${res.result === "heads" ? "Qızıl" : "Gümüş"} · ${res.won ? `+${fmtAZN(res.win)}` : "Uduzdunuz"}` : ""}
        </p>
      </div>
    </div>
  );
};
